import {AfterViewInit, Directive, input, Renderer2, signal, WritableSignal} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';

@Directive({
	selector: '[PasswordToggle]',
	exportAs: 'PasswordToggle',
	standalone: true,
})
export class PasswordToggleDirective implements AfterViewInit {
	public visibilityIcon: WritableSignal<string> = signal('visibility');

	public readonly visibilityIconRef = input.required<MatIcon>();

	constructor(
		private matInput: MatInput,
		private renderer: Renderer2,
	) {}

	ngAfterViewInit(): void {
		const visibilityIconEl = this.visibilityIconRef()._elementRef.nativeElement;
		visibilityIconEl.classList.add(...['cursor-pointer', 'password-toggle']);
		this.renderer.listen(visibilityIconEl, 'click', () => {
			this.togglePassword();
		});
	}

	public togglePassword(): void {
		this.matInput.type = this.matInput.type === 'password' ? 'text' : 'password';
		this.visibilityIcon.set(this.matInput.type === 'password' ? 'visibility' : 'visibility_off');
	}
}
